import { Component, inject } from '@angular/core';
import { HelpService } from './app/help/help.service';
import { HelpReaderComponent } from './app/help/help-reader.component';
import { RouterModule } from '@angular/router';
import { Toast } from 'primeng/toast';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, Toast, HelpReaderComponent],
    template: `<p-toast></p-toast><div [class.help-workspace]="help.visible()" [attr.inert]="help.visible() && help.compact() ? '' : null" [attr.aria-hidden]="help.visible() && help.compact() ? 'true' : null"><router-outlet></router-outlet></div>
    @defer (when help.visible()) { @if (help.visible()) { <aside class="help-panel" aria-label="Ajuda durante o trabalho"><app-help-reader /></aside> } }`,
    styles: [`.help-panel { position: fixed; inset: 0 0 0 auto; width: min(42rem, 46vw); z-index: 1100; border-left: 1px solid var(--p-content-border-color); box-shadow: -4px 0 18px #0001; } .help-workspace { margin-right: min(42rem, 46vw); } @media(max-width: 900px) { .help-panel { width: 100%; } .help-workspace { margin-right: 0; } }`]
})
export class AppComponent { readonly help = inject(HelpService); }
